import React, { useState, useEffect } from "react";
import "./DashboardpagesCss/ViewMembers.css";
import { useNavigate, useOutletContext } from "react-router-dom";
import nodatafound from "../../Assets/noDataFound.png";
import { AiFillEdit } from "react-icons/ai";
import { getProfileStatus, addMedicine, getMedicine } from "../../api/api";
import { getUserMobile } from "../../utils/auth";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import toast from "react-hot-toast";
import { MdAdd } from "react-icons/md";

const ViewMembers = () => {
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  // const { members } = useOutletContext();
  const navigator = useNavigate();
  const [activeTab, setActiveTab] = useState("Ongoing");
  const [medicineData, setMedicineData] = useState([]);

  const fromDate = new Date();
  const toDate = new Date();
  toDate.setDate(fromDate.getDate() + 7);

  const formatDateForInput = (date) => {
    return date.toISOString().split("T")[0];
  };

  const [selectedMemberData, setSelectedMemberData] = useState(null); // Changed from singleProfileData

  const [formData, setFormData] = useState({
    RBAuthKey: "RBDWAh!Q1s74e",
    PCode: "",
    Medicine: "",
    Type: "",
    DoseTime: "",
    Timings: "0-0-0", // Format: Morning-Afternoon-Night
    FromDate: formatDateForInput(fromDate),
    ToDate: formatDateForInput(toDate),
  });

  const [profileData, setProfileData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [singleProfileData, setSingleProfileData] = useState([]);

  // formet date
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const dateParts = dateString.split("-");
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
  };

  useEffect(() => {
    if (profileData.length > 0 && !selectedMemberData) {
      const defaultMember = profileData.find((m) => m.user_id === "PRB0844427");
      if (defaultMember) {
        setSelectedMemberData(defaultMember);
        setFormData((prev) => ({
          ...prev,
          selectedMember: "PRB0844427",
          PCode: defaultMember.user_id,
        }));
        fetchMedicineData(defaultMember.user_id);
      }
    }
  }, [profileData]);
  // updated handle change
  const handleChange = (e) => {
    // const { name, value } = e.target;

    const { name, value, type, checked } = e.target;

    if (name === "Timings") {
      // Convert checkbox to '1-0-0' format
      const timingsArray = formData.Timings.split("-");
      const timing = value;

      if (timing === "Morning") {
        timingsArray[0] = checked ? "1" : "0";
      } else if (timing === "Afternoon") {
        timingsArray[1] = checked ? "1" : "0";
      } else if (timing === "Night") {
        timingsArray[2] = checked ? "1" : "0";
      }

      setFormData({
        ...formData,
        Timings: timingsArray.join("-"),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    // If selectedMember is changed and has a value, find member from profileData
    if (name === "selectedMember" && value) {
      console.log("Selected User ID:", value);

      // Find the selected member from profileData
      const foundMember = profileData.find(
        (member) => member.user_id === value
      );
      if (foundMember) {
        setSelectedMemberData(foundMember);
        setFormData((prevData) => ({
          ...prevData,
          PCode: foundMember.user_id, // Update PCode with selected user_id
        }));
        console.log("Found Member:", foundMember);
        fetchMedicineData(foundMember.user_id);
      } else {
        setSelectedMemberData(null);
        setFormData((prevData) => ({
          ...prevData,
          PCode: "",
        }));
        setMedicineData([]);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Medicine Data:", formData);
    // alert("Medicine Saved!");
    fetchAddMedicine(formData);
  };

  // call addMedicine api

  const fetchAddMedicine = async (data) => {
    try {
      setLoading(true);
      // Convert dates to dd-mm-yyyy format before sending
      const formattedData = {
        ...data,
        FromDate: formatDateToDDMMYYYY(data.FromDate),
        ToDate: formatDateToDDMMYYYY(data.ToDate),
      };

      console.log("Formatted Data to Send:", formattedData);

      const res = await addMedicine(formattedData);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message || "Medicine added successfully!");

        // Refresh medicine data for current member
        if (formData.PCode) {
          await fetchMedicineData(formData.PCode);
        }

        // Reset form after successful submission
        setFormData({
          RBAuthKey: "RBDWAh!Q1s74e",
          PCode: formData.PCode, // Keep the selected member
          Medicine: "",
          Type: "",
          DoseTime: "",
          Timings: "0-0-0",
          FromDate: formatDateForInput(fromDate),
          ToDate: formatDateForInput(toDate),
        });

        // Switch to "Ongoing" tab to show the added medicine
        setActiveTab("Ongoing");
      } else {
        toast.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.error("Error adding medicine:", err);
      toast.error(
        err?.response?.data?.message || "Server error. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  // complete addMedicine api

  // helper function of ongoing
  // Check if medicine ToDate is greater than or equal to today
  const isOngoing = (toDate) => {
    if (!toDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Parse DD/MM/YYYY format from API (note the forward slashes)
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split("/");
      const parsedDate = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day)
      );
      parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    };

    const to = parseDate(toDate);

    // Medicine is ongoing if ToDate >= today
    return to >= today;
  };
  //

  const isTimingSelected = (timing) => {
    const timingsArray = formData.Timings.split("-");
    if (timing === "Morning") return timingsArray[0] === "1";
    if (timing === "Afternoon") return timingsArray[1] === "1";
    if (timing === "Night") return timingsArray[2] === "1";
    return false;
  };

  //   new render records

  const renderRecords = () => {
    switch (activeTab) {
      case "Ongoing":
        // Filter medicines where ToDate >= today
        const ongoingMedicines = medicineData.filter(
          (med) => med.ToDate && isOngoing(med.ToDate)
        );

        if (ongoingMedicines.length === 0) {
          return (
            <div className="no-data">
              <img src={nodatafound} alt="No Data" />
              <p>No ongoing medicines</p>
            </div>
          );
        }

        return (
          <div className="medicine-list">
            {ongoingMedicines.map((med, index) => {
              // Use Column1 instead of Timings
              const timings = (med.Column1 || "0-0-0").split("-");
              return (
                <div key={med.ID || index} className="medicine-card">
                  <div className="medicine-header">
                    <h4>{med.Medicine || "N/A"}</h4>
                    <div className="medicine-actions">
                      <button className="edit-btn">✏️</button>
                      <button className="delete-btn">🗑️</button>
                    </div>
                  </div>

                  <div className="medicine-timing">
                    <span className="timing-label">Morning</span>
                    <span className="timing-value">{timings[0]}</span>

                    <span className="timing-label">Noon</span>
                    <span className="timing-value">{timings[1]}</span>

                    <span className="timing-label">Night</span>
                    <span className="timing-value">{timings[2]}</span>
                  </div>

                  <div className="medicine-details">
                    <p>
                      <strong>Type:</strong> {med.Type || "N/A"}
                    </p>
                    <p>
                      <strong>Dose Time:</strong> {med.DoseTime || "N/A"}
                    </p>
                    {med.Doctor && (
                      <p>
                        <strong>Doctor:</strong> {med.Doctor}
                      </p>
                    )}
                    <p>
                      <strong>Duration:</strong> {med.FromDate || "N/A"} to{" "}
                      {med.ToDate || "N/A"}
                    </p>
                  </div>

                  <div className="medicine-status">
                    <span className="ongoing-badge">Ongoing</span>
                  </div>
                </div>
              );
            })}
          </div>
        );

      case "All":
        // Check for empty data only in All tab
        if (!medicineData || medicineData.length === 0) {
          return (
            <div className="no-data">
              <img src={nodatafound} alt="No Data" />
              <p>No medicines found for this member</p>
            </div>
          );
        }

        return (
          <div className="medicine-list">
            {medicineData.map((med, index) => {
              // Use Column1 instead of Timings
              const timings = (med.Column1 || "0-0-0").split("-");
              const isCurrentlyOngoing = med.ToDate && isOngoing(med.ToDate);

              return (
                <div key={med.ID || index} className="medicine-card">
                  <div className="medicine-header">
                    <h4>{med.Medicine || "N/A"}</h4>
                    <div className="medicine-actions">
                      <button className="edit-btn">✏️</button>
                      <button className="delete-btn">🗑️</button>
                    </div>
                  </div>

                  <div className="medicine-timing">
                    <span className="timing-label">Morning</span>
                    <span className="timing-value">{timings[0]}</span>

                    <span className="timing-label">Noon</span>
                    <span className="timing-value">{timings[1]}</span>

                    <span className="timing-label">Night</span>
                    <span className="timing-value">{timings[2]}</span>
                  </div>

                  <div className="medicine-details">
                    <p>
                      <strong>Type:</strong> {med.Type || "N/A"}
                    </p>
                    <p>
                      <strong>Dose Time:</strong> {med.DoseTime || "N/A"}
                    </p>
                    {med.Doctor && (
                      <p>
                        <strong>Doctor:</strong> {med.Doctor}
                      </p>
                    )}
                    <p>
                      <strong>Duration:</strong> {med.FromDate || "N/A"} to{" "}
                      {med.ToDate || "N/A"}
                    </p>
                  </div>

                  <div className="medicine-status">
                    {isCurrentlyOngoing ? (
                      <span className="ongoing-badge">Ongoing</span>
                    ) : (
                      <span className="completed-badge">Completed</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );

      case "Add New":
        return (
          <form className="medicine-form" onSubmit={handleSubmit}>
            {/* Your existing Add New form */}
            <div className="form-group full-width">
              <label>Medicine Name</label>
              <input
                type="text"
                name="Medicine"
                placeholder="Enter Medicine Name"
                value={formData.Medicine}
                onChange={handleChange}
              />
            </div>

            <div className="form-row ex-gap">
              <div className="form-group">
                <label>Type</label>
                <select
                  name="Type"
                  className="form-select fx-grid select-form-view"
                  value={formData.Type}
                  onChange={handleChange}
                  style={{
                    width:"auto"
                  }}
                >
                  <option value="">Select Type</option>
                  <option value="Tablet">Tablet</option>
                  <option value="Capsule">Capsule</option>
                  <option value="Injection">Injection</option>
                  <option value="Syrup">Syrup</option>
                </select>
              </div>

              <div className="form-group">
                <label>Dose Time</label>
                <select
                  name="DoseTime"
                  value={formData.DoseTime}
                  onChange={handleChange}
                  className="form-select fx-grid select-form-view"
                  style={{
                    width:"auto"
                  }}
                >
                  <option value="">Select Instruction</option>
                  <option value="Before Food">Before Food</option>
                  <option value="After Food">After Food</option>
                  <option value="With Food">With Food</option>
                </select>
              </div>

              <div className="form-group">
                <label>Timings</label>
                <div className="dose-options">
                  {["Morning", "Afternoon", "Night"].map((timing) => (
                    <label key={timing}>
                      <input
                        type="checkbox"
                        className="viewInput"
                        name="Timings"
                        value={timing}
                        checked={isTimingSelected(timing)}
                        onChange={handleChange}
                      />
                      {timing}
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  name="FromDate"
                  value={formData.FromDate}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  name="ToDate"
                  value={formData.ToDate}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="rbdButton btn">
                <span className="btn-text">Save Medicine</span>
              </button>
            </div>
          </form>
        );

      default:
        return <p>No Records Found</p>;
    }
  };

  const members = [
    {
      id: "M001",
      name: "Rajesh Mukherjee",
      relation: "Self",
      age: 42,
      gender: "Male",
      bloodGroup: "B+",
      contact: "9876543210",
      address: "Bongaon, West Bengal",
      existingConditions: ["Hypertension"],
      allergies: ["Penicillin"],
      ongoingMedication: ["Amlodipine 5mg"],
      recentTests: [
        { test: "Blood Sugar", date: "2025-08-12", result: "Normal" },
        { test: "ECG", date: "2025-07-20", result: "Minor Variations" },
      ],
    },
    {
      id: "M002",
      name: "Anita Mukherjee",
      relation: "Wife",
      age: 38,
      gender: "Female",
      bloodGroup: "O+",
      contact: "9876543211",
      address: "Bongaon, West Bengal",
      existingConditions: ["Thyroid"],
      allergies: [],
      ongoingMedication: ["Thyroxine 50mcg"],
      recentTests: [
        {
          test: "Thyroid Function Test",
          date: "2025-09-01",
          result: "Elevated TSH",
        },
        { test: "Lipid Profile", date: "2025-08-10", result: "Normal" },
      ],
    },
    {
      id: "M003",
      name: "Rohit Mukherjee",
      relation: "Son",
      age: 14,
      gender: "Male",
      bloodGroup: "A+",
      contact: "9876543212",
      address: "Bongaon, West Bengal",
      existingConditions: [],
      allergies: ["Dust"],
      ongoingMedication: [],
      recentTests: [{ test: "CBC", date: "2025-09-10", result: "Mild Anemia" }],
    },
    {
      id: "M004",
      name: "Sneha Mukherjee",
      relation: "Daughter",
      age: 10,
      gender: "Female",
      bloodGroup: "O+",
      contact: "9876543213",
      address: "Bongaon, West Bengal",
      existingConditions: [],
      allergies: [],
      ongoingMedication: [],
      recentTests: [
        { test: "Vitamin D", date: "2025-08-25", result: "Deficient" },
      ],
    },
    {
      id: "M005",
      name: "Sushil Mukherjee",
      relation: "Father",
      age: 68,
      gender: "Male",
      bloodGroup: "B+",
      contact: "9876543214",
      address: "Bongaon, West Bengal",
      existingConditions: ["Diabetes", "Hypertension"],
      allergies: [],
      ongoingMedication: ["Metformin 500mg", "Aspirin 75mg"],
      recentTests: [
        { test: "HbA1c", date: "2025-09-05", result: "8.2% (High)" },
        {
          test: "Kidney Function Test",
          date: "2025-08-15",
          result: "Borderline",
        },
      ],
    },
    {
      id: "M006",
      name: "Kamala Mukherjee",
      relation: "Mother",
      age: 65,
      gender: "Female",
      bloodGroup: "A-",
      contact: "9876543215",
      address: "Bongaon, West Bengal",
      existingConditions: ["Arthritis"],
      allergies: ["Seafood"],
      ongoingMedication: ["Calcium + Vitamin D3"],
      recentTests: [
        {
          test: "Bone Density Test",
          date: "2025-09-02",
          result: "Osteoporosis Detected",
        },
      ],
    },
  ];

  const [showAll, setShowAll] = useState(false);
  const handleAddMember = (e) => {
    e.preventDefault();
    navigator("/dashboard/add-member");
  };

  // api call Profile
  useEffect(() => {
    fetchProfileListData();
    // fetchMedicineData()
  }, []);

  const fetchProfileListData = async () => {
    try {
      // 🧾 Prepare API payload
      const mobile = getUserMobile();
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: "",
        mobile_no: mobile,
      };

      console.log("Profile check payload:", payload);

      // 📡 API call
      setLoading(true);
      const response = await getProfileStatus(payload);
      console.log("Profile Status Response:", response);

      if (response?.data?.status === "success") {
        setProfileData(response.data.data || {});
      } else {
        console.error("Profile fetch failed:", response?.data?.message);
        // toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      console.error("Unexpected error fetching profile data:", error);
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  // Add this after your fetchProfileListData function

  const fetchMedicineData = async (pCode) => {
    // Don't fetch if no pCode
    if (!pCode) {
      setMedicineData([]);
      return;
    }

    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        PCode: pCode,
      };
      console.log("Medicine check payload:", payload);

      setLoading(true);
      const response = await getMedicine(payload);
      console.log("Medicine Response:", response);

      if (response?.data?.status === "success") {
        setMedicineData(response.data.data || []);
      } else {
        console.error("Medicine fetch failed:", response?.data?.message);
        // toast.error(response?.data?.message || "Unable to fetch medicine data");
        setMedicineData([]);
      }
    } catch (error) {
      console.error("Unexpected error fetching medicine data:", error);
      toast.error("Something went wrong while loading medicine data.");
      setMedicineData([]);
    } finally {
      setLoading(false);
    }
  };
  console.log("medicineData==>", medicineData);

  // profile api call complete

  // call getMedicine api

  // call getMedicine api complete
  console.log("profile data==>", profileData);
  console.log("selectedMemberData==>", selectedMemberData);

  console.log("medicine formdata ==>", formData);
  console.log("medicineData==>", medicineData);

  const handleEditMembers = (e) => {
    e.preventDefault();
    if (!selectedMemberData) {
      toast.error("Please select a member to edit");
      return;
    }
    navigator("/dashboard/edit-profile", { state: { profileData: [selectedMemberData] ,from: "view-member"} });
  }

  return (
    <div className="container">
      <div className="profile-header">
        <h2>View Members</h2>
      </div>
      <div className="view-members-container">
        {/* Left Side */}
        <div className="members-card">
          <div className="doctorTopSec">
            <h3 style={{ color: "black" }} className="member-text">
              Members
            </h3>
            <div className="editButtonDiv">
              <button className="rbdButton" onClick={handleAddMember}>
                <span className="btn-text">
                  <MdAdd size={18} /> Add New Member
                </span>
              </button>
              <button className="rbdButton" onClick={handleEditMembers}>
                <span className="btn-text">
                  <AiFillEdit /> Edit Members
                </span>
              </button>
            </div>
          </div>
          {/* <h3 className="card-title">Members</h3> */}
          <div className="form-group" style={{ marginTop: "1rem" }}>
            <label>Select Member</label>

            {/* <select
                            name="selectedMember"
                            value={formData.selectedMember || ""}
                            onChange={handleChange}
                            className="form-select select-form-view"
                        >
                            <option value="">-- Select Member --</option>
                            {profileData.map((m, index) => (
                                <option key={index} value={m.user_id}>
                                    {`${m.PTitle} ${m.PFirstName} ${m.PLastName}`}
                                </option>
                            ))}
                        </select> */}

            {/* new added  */}
            <FormControl fullWidth className="custom-select-formcontrol">
              <Select
                name="selectedMember"
                value={formData.selectedMember || "PRB0844427"}
                onChange={handleChange}
                // displayEmpty
                className="custom-select-input"
                MenuProps={{
                  PaperProps: {
                    className: "custom-select-menu",
                  },
                }}
              >
                {/* <MenuItem value="" className="custom-menu-item">
                                    -- Select Member --
                                </MenuItem> */}
                {profileData.map((m, index) => (
                  <MenuItem
                    key={index}
                    value={m.user_id}
                    className="custom-menu-item"
                  >
                    {`${m.PTitle} ${m.PFirstName} ${m.PLastName}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* new added  */}

            {/* <div className="members-list">
                        {(showAll ? members : members.slice(0, 4)).map((m, index) => (
                            <div className="member-card" key={index}>
                                <p><strong>{m.name}</strong></p>
                                <p>Relation: {m.relation}</p>
                            </div>
                        ))}
                    </div> */}

            <div className="member-details">
              <p>
                <strong>Full Name:</strong>{" "}
                {(selectedMemberData?.PFirstName || "") +
                  " " +
                  (selectedMemberData?.PLastName || "")}
              </p>
              <p>
                <strong>Mobile No:</strong> {selectedMemberData?.mobile_no}
              </p>
              <p>
                <strong>Address:</strong> {selectedMemberData?.address}
              </p>
              <p>
                <strong>D.O.B:</strong> {selectedMemberData?.dateofbirth}
              </p>
              <p>
                <strong>Alt Mobile:</strong> {selectedMemberData?.alt_mobile_no}
              </p>
              <p>
                <strong>Zipcode:</strong> {selectedMemberData?.Zipcode}
              </p>
              <p>
                <strong>Gender:</strong> {selectedMemberData?.PSex}
              </p>
              <p>
                <strong>Email-ID:</strong> {selectedMemberData?.email}
              </p>
              <p>
                <strong>Landmark:</strong> {selectedMemberData?.landmark}
              </p>
            </div>
          </div>

          {/* View More / Less Toggle */}
          {/* {members.length > 4 && (
                        <button
                            className="rbdButton view-toggle-btn"
                            onClick={() => setShowAll(!showAll)}
                        >
                            <span className="btn-text">{showAll ? "View Less" : "View More"}</span>
                        </button>
                    )} */}
        </div>

        {/* Right Side */}
        <div className="tabs-card">
            <h3>Medicine</h3>
          <div className="member-tabs">
            <button
              className={`tab ${activeTab === "Ongoing" ? "active" : ""}`}
              onClick={() => setActiveTab("Ongoing")}
            >
              Ongoing
            </button>
            <button
              className={`tab ${activeTab === "All" ? "active" : ""}`}
              onClick={() => setActiveTab("All")}
            >
              All
            </button>

            <button
              className={`tab ${activeTab === "Add New" ? "active" : ""}`}
              onClick={() => setActiveTab("Add New")}
            >
              + Add New
            </button>
          </div>
          <div className="records-box">{renderRecords()}</div>
        </div>
      </div>
    </div>
  );
};

export default ViewMembers;
